import React, { useContext, useState } from "react";
import Logo from "../../Assets/logo.png";
import { AppContext } from "../../Context/AppContext";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";

function ResetPassword() {
  const navigate = useNavigate();
  const { resetReq, authLoading } = useContext(AppContext);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      alert("Please enter a valid email address");
      return;
    }

    await resetReq(
      { email },
      {
        onSuccess: (res) => {
          toast.success("Otp Request sent successfully!");
          navigate("/verify-otp");
          sessionStorage.setItem("email", res.data.email);
          sessionStorage.setItem("id", res.data._id);
        },
        onFailed: (err) => {
          const errMsg = err.message ?? "Something went wrong!";
          toast.error(errMsg);
        },
      }
    );
  };
  return (
    <>
      <Toaster />
      <div className="email-container">
        <form className="email-form" onSubmit={handleSubmit}>
          <div className="logo-container">
            <img src={Logo} alt="Logo" className="logo-img" />
          </div>
          <h2 className="email-title">Enter Your Email</h2>
          <p className="email-subtitle">
            We’ll send a verification code to this email
          </p>
          <input
            type="email"
            className="email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="example@email.com"
            required
          />

          <button type="submit" className="email-btn" disabled={authLoading}>
           {authLoading ? <PulseLoader color="#fff" size={10} /> : "Send OTP"}
          </button>
        </form>
      </div>
    </>
  );
}

export default ResetPassword;
